
// 请求接口列表
export default {
  // 文件版本列表
  getFileVersionList: '/doclogic/v1/file/version/list',
  // 文件版本列表
  teamlibSet: '/doclogic/v1/doclibrary/teamlib/libSet',
  // 文件版本恢复
  fileVersionReset: '/doclogic/v1/file/version/reset',
  // 通过、驳回、撤回三种操作
  fileReleaseAudit: '/doclogic/v1/doclibrary/teamlib/fileRelease/audit',
  // 文件发布
  filePublish: '/doclogic/v1/doclibrary/file/publish',
  // 获取文件发布信息
  getReleaseinfo: '/doclogic/v1/doclibrary/file/releaseinfo',
  // 查询在线文档历史版本发布记录映射
  getReleasemap: '/doclogic/v1/doclibrary/file/online/releasemap',
  // 获取文件预览URL（带水印）， source = APP 、WEB 、DESKTOP (移动端或者PC端,默认WEB)
  getWaterMarkUrl: '/doclogic/v1/wopi/getWaterMarkUrl'
}
